import React from 'react';

/** 소스코드 블럭 편집 화면 자리 표시 — 스캔 이미지 블럭과 같은 반투명 박스 (프레젠테이션 편집·평가지 공용) */
const SlideCodeBlockPlaceholder: React.FC = () => (
  <div className="cp-program-slide-canvas-image-placeholder cp-program-slide-canvas-scan-placeholder-static">
    소스코드 블럭
  </div>
);

export default SlideCodeBlockPlaceholder;
